import { TFileMessageOutputDto } from "@/api/services/admin/conversation/dtos/create-message.dto";
import { IconFile } from "@/assets/icons";
import { textEllipsis } from "@/theme/minxin";
import { typography } from "@/theme/typography";
import { Box, Stack, StackProps, Typography, styled } from "@mui/material";
import { FC } from "react";

type TMessageFileInfoProps = {
  file: TFileMessageOutputDto;
  color: string;
} & StackProps;

export const MessageFileInfo: FC<TMessageFileInfoProps> = ({ file, color, ...rest }) => {
  return (
    <Stack {...rest} gap={0.5}>
      <Stack direction="row" alignItems="center">
        <FileItemWrap>
          <IconFile fontSize="32px" color={color} />
          <FileName color={color}>{file.name}</FileName>
        </FileItemWrap>
      </Stack>
    </Stack>
  );
};

const FileItemWrap = styled(Box)`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
  margin-right: 4px;
`;

const FileName = styled(Typography)`
  ${textEllipsis};
  ${typography.body14};
  flex: 1;
`;
